export const iconFontAwesomeCampingTents = (
	<i className="fa-solid fa-tents"></i>
);
